import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import React, { useEffect } from "react";
import { areObjectsEqualAsStrings } from "Helpers/util";
import { useDispatch, useSelector } from "react-redux";
import NavBar from "ProfileComponents/Navigation/NavBar";
import BottomBar from "../common/BottomBar";
import UpdatedProducts from "./UpdatedProducts";
import "./my_profile.scss";
import RetakeQuiz from "./RetakeQuiz";
import { useScreenWidth } from "../SubscriptionPageV2/hooks";
import TranslucentNavbar from "../common/TranslucentNavbar/TranslucentNavbar";
import { changeProductsStatus, setSelectedAnswers, editModelObject, setProfileStoreAction, } from "../../redux/actionCreators/makeActionCreator";
import { fetchProfileDataThunk, saveProfileDataThunk } from "../../redux/thunkCreators/myProfile/profileThunk";
import { useLocation } from "react-router";
import H2Font from "../common/H2Font";
const MyProfile = () => {
    const reduxStoreIsEmpty = useSelector((state) => state.checkStore.profile);
    const isMobile = useScreenWidth() < 768;
    const dispatch = useDispatch();
    const myProfileState = useSelector((state) => state.myProfile);
    const user = useSelector((state) => state.user);
    const { hash } = useLocation();
    useEffect(() => {
        if (reduxStoreIsEmpty) {
            dispatch(fetchProfileDataThunk());
            dispatch(setProfileStoreAction(false));
        }
    }, []);
    const onChange = (value, name) => {
        dispatch(setSelectedAnswers({ ...myProfileState.selectedAnswers, [name]: value }));
    };
    const onCancel = () => {
        dispatch(setSelectedAnswers({ ...myProfileState.originalAnswers }));
    };
    const setEditMode = (value, name) => {
        dispatch(editModelObject({ ...myProfileState.editModeObj, [name]: value }));
    };
    const onSave = (event) => {
        event.preventDefault();
        dispatch(saveProfileDataThunk());
    };
    const { nav_visibility } = useSelector((state) => state.components);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        if (hash) {
            document.getElementById(hash.substr(1))?.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [hash]);
    useEffect(() => {
        if (areObjectsEqualAsStrings(myProfileState.originalAnswers, myProfileState.selectedAnswers)) {
            const launcher = document.getElementById("launcher");
            if (launcher) {
                launcher.style.zIndex = "100";
            }
        }
    }, [myProfileState.originalAnswers, myProfileState.selectedAnswers]);
    return (_jsxs(_Fragment, { children: [nav_visibility && (_jsx(NavBar, { userName: user.full_name, showTop: true, userLoggedIn: true, hasSubscription: user.has_subscription, bannerData: user.banner_data })), isMobile && (_jsx(TranslucentNavbar, { animated: true, children: _jsx("h4", { children: "About You" }) })), _jsx("div", { className: "my-profile", children: _jsxs("form", { onSubmit: onSave, children: [myProfileState.isChanged ? (_jsx(UpdatedProducts, { productsChanged: myProfileState.productsChanged, onConfirm: () => dispatch(changeProductsStatus(false)), onCancel: () => dispatch(changeProductsStatus(false)) })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: "my-profile__title", children: _jsx(H2Font, { children: "About You" }) }), _jsx("div", { className: "my-profile__container", children: _jsxs("div", { className: "my-profile__quiz-options-wrapper", children: [_jsx("div", { className: "my-profile__separator" }), _jsx(RetakeQuiz, { asDrawer: false })] }) }), !areObjectsEqualAsStrings(myProfileState.originalAnswers, myProfileState.selectedAnswers) && (_jsx(BottomBar, { isRounded: true, type: "submit", cancelLabel: "Cancel", submitLabel: "Save Changes", onCancel: onCancel }))] })), _jsx("div", {})] }) })] }));
};
export default MyProfile;
